import axios from "axios"
import {BUOY_API_BASE} from "./constants"

const argsToForm = args => {
  let data = new FormData()
  Object.keys(args).forEach(key => {
    if (args.hasOwnProperty(key)) {
      data.append(key, args[key])
    }
  })
  return data
}

const axiosInstance = axios.create({
  baseURL: BUOY_API_BASE,
  withCredentials: true,
  maxRedirects: 0,
  timeout: 1500,
  headers: { "Content-Type": "multipart/form-data" },
})

const http = (url, method, args, params) => {
  let data = args ? argsToForm(args) : undefined
  return axiosInstance({
    method: method,
    url: url,
    data: data,
    params: params,
  }).then(r => {
    return r.data ? r.data : r
  })
}

export { http as default }



// WEBPACK FOOTER //
// ./src/common/http.js